// lightingStatus — derive the runtime lighting-LOAD status for the status chip
// from the two volume globals (__LIGHT_PROBE_GRID__ / __REFLECTION_CAPTURES__).
//
// The gap this closes: after a bake finishes, the runtime still has to fetch the
// artifacts (a small diffuse grid, then ~N large reflection equirects). During
// that window the chip previously showed "not baked" (amber) — indistinguishable
// from genuinely-unbaked — so a loading scene read as broken. This surfaces an
// explicit, evident "loading reflections N/M" state instead.
//
// Pure (no window/DOM) so it's unit-testable; the chip passes the two globals in.
export function lightingLoadStatus(grid, refl) {
  const gridState = grid?.state
  const reflState = refl?.state

  // Actively fetching artifacts into the scene (bake already done server-side).
  const loading = gridState === 'pending' || reflState === 'pending'

  // Fully in the scene: diffuse grid applied and reflections not still streaming
  // (applied, or legitimately absent/disabled — diffuse-only is still "ready").
  const ready = gridState === 'applied' && reflState !== 'pending'

  let label = ''
  if (reflState === 'pending') {
    const total = Number(refl?.total) || 0
    const done = Number(refl?.loaded) || 0
    label = total > 0 ? `loading reflections ${done}/${total}` : 'loading reflections…'
  } else if (gridState === 'pending') {
    label = 'loading lighting…'
  }

  return { loading, ready, label }
}
